export default __webpack_public_path__ + "static/media/ps_modal_wire_red.b5a275c0.svg";